import { FeatureFlagItem, FeatureFlagHighlight } from './FeatureFlagGeneric';

export class EdgeConfig {
    featureFlag: Array<FeatureFlagItem>;
    featureHighlight: Array<FeatureFlagHighlight>;
    whitelabelSwitch: boolean;
    allowDelivery: boolean;
    applyBuffer: boolean;
    catering: {
        featureFlag: Array<FeatureFlagItem>;
        featureHighlight: Array<FeatureFlagHighlight>;
        allowDelivery: boolean;
    };

    constructor(init?: Partial<EdgeConfig>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): EdgeConfig {
        const featureFlag = obj.featureFlag || [];
        const featureHighlight = obj.featureHighlight || [];

        const cateringFeatureFlag = obj.catering.featureFlag || [];
        const cateringFeatureHighlight = obj.catering.featureHighlight || [];

        return new EdgeConfig({
            featureFlag: featureFlag.map((item: any) => FeatureFlagItem.Make(item)),
            featureHighlight: featureHighlight.map((item: any) => FeatureFlagHighlight.Make(item)),
            whitelabelSwitch: Boolean(obj.whitelabelSwitch),
            allowDelivery: Boolean(obj.allowDelivery),
            applyBuffer: obj.applyBuffer ?? true,
            catering: {
                featureFlag: cateringFeatureFlag.map((item: any) => FeatureFlagItem.Make(item)),
                featureHighlight: cateringFeatureHighlight.map((item: any) => FeatureFlagHighlight.Make(item)),
                allowDelivery: Boolean(obj.catering.allowDelivery),
            },
        });
    }
}
